const translations = {
    dry: 'Spread'
};

export default translations;
